<app-header></app-header>

<div class="min-h-screen pb-20">
  <div class="max-w-5xl mx-auto px-6 py-8">

    <!-- Título -->
    <div class="mb-8">
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white">Editar Marca — Brand Manager</h1>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">
        Configure a identidade visual do POS para cada cliente/domínio em
        <a href="https://brandingmngr.clinicasim.com" target="_blank"
           class="text-[var(--brand-primary)] font-medium hover:underline">brandingmngr.clinicasim.com</a>.
        As alterações são aplicadas em tempo real — sem rebuild necessário.
      </p>
    </div>

    <!-- Campos Principais -->
    <section class="mb-10">
      <h2 class="text-base font-semibold text-gray-900 dark:text-white mb-3 pb-2 border-b border-gray-200 dark:border-zinc-700">Campos Principais</h2>
      <div class="overflow-x-auto rounded-lg border border-gray-200 dark:border-zinc-700">
        <table class="w-full text-sm">
          <thead class="bg-gray-100 dark:bg-zinc-800 text-gray-700 dark:text-gray-200">
            <tr>
              <th class="px-4 py-3 text-left font-semibold w-32">Campo</th>
              <th class="px-4 py-3 text-left font-semibold">Descrição</th>
              <th class="px-4 py-3 text-left font-semibold w-56">Onde aparece</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-zinc-700 text-gray-700 dark:text-gray-300">
            <tr class="bg-white dark:bg-zinc-900">
              <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">brandName</td>
              <td class="px-4 py-3">Nome comercial da marca. Usado no título da aba e na pré-visualização.</td>
              <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Título da página, header</td>
            </tr>
            <tr class="bg-gray-50 dark:bg-zinc-800/50">
              <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">domain</td>
              <td class="px-4 py-3">Domínio ou IP que identifica o cliente. O POS detecta automaticamente e carrega a marca correspondente.</td>
              <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Chave de busca — não visível ao usuário</td>
            </tr>
            <tr class="bg-white dark:bg-zinc-900">
              <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">logo</td>
              <td class="px-4 py-3">Logotipo em base64 (PNG com fundo transparente). Recomendado: até 200 KB, resolução mínima 400×200 px.</td>
              <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Card de login, header, footer (fallback)</td>
            </tr>
            <tr class="bg-gray-50 dark:bg-zinc-800/50">
              <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">primaryColor</td>
              <td class="px-4 py-3">Cor principal da marca. Aplicada em botões de ação, links ativos, ícones de destaque.</td>
              <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Botões primários, bordas ativas, ícones</td>
            </tr>
            <tr class="bg-white dark:bg-zinc-900">
              <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">secondaryColor</td>
              <td class="px-4 py-3">Cor de apoio. Usada em botões de confirmação e elementos secundários.</td>
              <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Botões de confirmar, hover states</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- Dados Adicionais -->
    <section class="mb-10">
      <h2 class="text-base font-semibold text-gray-900 dark:text-white mb-1 pb-2 border-b border-gray-200 dark:border-zinc-700">
        Dados Adicionais <span class="font-mono text-sm text-gray-500">additionalData</span>
      </h2>
      <p class="text-sm text-gray-500 dark:text-gray-400 mb-5">Parâmetros avançados configurados como chave/valor no Brand Manager.</p>

      <!-- CORES E VISUAL -->
      <div class="mb-6">
        <div class="bg-[var(--brand-accent)] text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-t-lg">Cores e Visual</div>
        <div class="overflow-x-auto border border-t-0 border-gray-200 dark:border-zinc-700 rounded-b-lg">
          <table class="w-full text-sm">
            <thead class="bg-gray-100 dark:bg-zinc-800 text-gray-700 dark:text-gray-200">
              <tr>
                <th class="px-4 py-2 text-left font-semibold w-36">Chave</th>
                <th class="px-4 py-2 text-left font-semibold">Descrição</th>
                <th class="px-4 py-2 text-left font-semibold w-28">Exemplo</th>
                <th class="px-4 py-2 text-left font-semibold w-40">Onde aparece</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100 dark:divide-zinc-700 text-gray-700 dark:text-gray-300">
              <tr class="bg-white dark:bg-zinc-900">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">sidebarBg</td>
                <td class="px-4 py-3">Cor de fundo do header superior e barra de topo. Geralmente um tom escuro da identidade da marca.</td>
                <td class="px-4 py-3"><span class="inline-flex items-center gap-1.5"><span class="w-4 h-4 rounded border border-gray-300" style="background:#101820"></span><code class="text-xs">#101820</code></span></td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Header superior</td>
              </tr>
              <tr class="bg-gray-50 dark:bg-zinc-800/50">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">menuBg</td>
                <td class="px-4 py-3">Cor de fundo do menu lateral (gaveta). Use cor escura quando o logo tiver letras claras.</td>
                <td class="px-4 py-3"><span class="inline-flex items-center gap-1.5"><span class="w-4 h-4 rounded border border-gray-300" style="background:#0F1F3E"></span><code class="text-xs">#0F1F3E</code></span></td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Menu lateral</td>
              </tr>
              <tr class="bg-white dark:bg-zinc-900">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">menuTextColor</td>
                <td class="px-4 py-3">Cor dos textos dentro do menu lateral (nome da unidade, links de navegação, botão sair). Deve contrastar com menuBg.</td>
                <td class="px-4 py-3"><span class="inline-flex items-center gap-1.5"><span class="w-4 h-4 rounded border border-gray-300" style="background:#FFFFFF"></span><code class="text-xs">#FFFFFF</code></span></td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Menu lateral</td>
              </tr>
              <tr class="bg-gray-50 dark:bg-zinc-800/50">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">accentColor</td>
                <td class="px-4 py-3">Cor de destaque para badges, tags, cabeçalhos de tabela e ícones de status.</td>
                <td class="px-4 py-3"><span class="inline-flex items-center gap-1.5"><span class="w-4 h-4 rounded border border-gray-300" style="background:#402870"></span><code class="text-xs">#402870</code></span></td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Badges, tabelas, widgets</td>
              </tr>
              <tr class="bg-white dark:bg-zinc-900">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">textOnPrimary</td>
                <td class="px-4 py-3">Cor do texto exibido sobre fundos com a cor do sidebar. Use <code>#FFFFFF</code> para fundos escuros.</td>
                <td class="px-4 py-3"><span class="inline-flex items-center gap-1.5"><span class="w-4 h-4 rounded border border-gray-300" style="background:#FFFFFF"></span><code class="text-xs">#FFFFFF</code></span></td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Header superior</td>
              </tr>
              <tr class="bg-gray-50 dark:bg-zinc-800/50">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">loginBg</td>
                <td class="px-4 py-3">Cor de fundo da página de login (área ao redor do card).</td>
                <td class="px-4 py-3"><span class="inline-flex items-center gap-1.5"><span class="w-4 h-4 rounded border border-gray-300" style="background:#e5e7eb"></span><code class="text-xs">#e5e7eb</code></span></td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Tela de login</td>
              </tr>
              <tr class="bg-white dark:bg-zinc-900">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">loginCardBg</td>
                <td class="px-4 py-3">Cor de fundo do card (caixinha) de login. Use cor escura quando o logo tiver letras brancas.</td>
                <td class="px-4 py-3"><span class="inline-flex items-center gap-1.5"><span class="w-4 h-4 rounded border border-gray-300" style="background:#0F1F3E"></span><code class="text-xs">#0F1F3E</code></span></td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Card de login</td>
              </tr>
              <tr class="bg-gray-50 dark:bg-zinc-800/50">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">loginCardText</td>
                <td class="px-4 py-3">Cor dos labels (Usuário, Senha) e subtítulo dentro do card de login. Deve contrastar com loginCardBg.</td>
                <td class="px-4 py-3"><span class="inline-flex items-center gap-1.5"><span class="w-4 h-4 rounded border border-gray-300" style="background:#FFFFFF"></span><code class="text-xs">#FFFFFF</code></span></td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Card de login</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- TEXTOS E IDENTIDADE -->
      <div class="mb-6">
        <div class="bg-[var(--brand-accent)] text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-t-lg">Textos e Identidade</div>
        <div class="overflow-x-auto border border-t-0 border-gray-200 dark:border-zinc-700 rounded-b-lg">
          <table class="w-full text-sm">
            <thead class="bg-gray-100 dark:bg-zinc-800 text-gray-700 dark:text-gray-200">
              <tr>
                <th class="px-4 py-2 text-left font-semibold w-36">Chave</th>
                <th class="px-4 py-2 text-left font-semibold">Descrição</th>
                <th class="px-4 py-2 text-left font-semibold w-48">Exemplo</th>
                <th class="px-4 py-2 text-left font-semibold w-40">Onde aparece</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100 dark:divide-zinc-700 text-gray-700 dark:text-gray-300">
              <tr class="bg-white dark:bg-zinc-900">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">pageTitle</td>
                <td class="px-4 py-3">Título personalizado na aba do browser. Se não informado, usa o brandName.</td>
                <td class="px-4 py-3 text-xs text-gray-600 dark:text-gray-400">POS - Super Clínica</td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Aba do browser</td>
              </tr>
              <tr class="bg-gray-50 dark:bg-zinc-800/50">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">footerTagline</td>
                <td class="px-4 py-3">Texto de tagline exibido abaixo do logo no footer. Deixe vazio <code>""</code> para ocultar.</td>
                <td class="px-4 py-3 text-xs text-gray-600 dark:text-gray-400">healthcare platform</td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Footer, tela de login</td>
              </tr>
              <tr class="bg-white dark:bg-zinc-900">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">footerCopyright</td>
                <td class="px-4 py-3">Texto de copyright exibido no canto direito do footer.</td>
                <td class="px-4 py-3 text-xs text-gray-600 dark:text-gray-400">Copyright © 2024 M & L...</td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Footer, tela de login</td>
              </tr>
              <tr class="bg-gray-50 dark:bg-zinc-800/50">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">supportEmail</td>
                <td class="px-4 py-3">E-mail de suporte do cliente. Exibido em mensagens de erro e páginas de contato.</td>
                <td class="px-4 py-3 text-xs text-gray-600 dark:text-gray-400">ti&#64;clinicasim.com</td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Mensagens de erro</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- INTEGRAÇÃO / BANCO DE DADOS -->
      <div class="mb-6">
        <div class="bg-[var(--brand-accent)] text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-t-lg">Integração / Banco de Dados</div>
        <div class="overflow-x-auto border border-t-0 border-gray-200 dark:border-zinc-700 rounded-b-lg">
          <table class="w-full text-sm">
            <thead class="bg-gray-100 dark:bg-zinc-800 text-gray-700 dark:text-gray-200">
              <tr>
                <th class="px-4 py-2 text-left font-semibold w-36">Chave</th>
                <th class="px-4 py-2 text-left font-semibold">Descrição</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100 dark:divide-zinc-700 text-gray-700 dark:text-gray-300">
              <tr class="bg-white dark:bg-zinc-900">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">cdEmpresa</td>
                <td class="px-4 py-3">
                  Código da empresa no Tasy (<code>CD_EMPRESA</code>). Define qual empresa será considerada no filtro de estabelecimentos.<br>
                  <span class="text-xs text-gray-500 mt-1 block">Se não informado, usa <strong>2</strong> (Clínica SiM) como padrão.</span>
                </td>
              </tr>
              <tr class="bg-gray-50 dark:bg-zinc-800/50">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">estabelecimentosIds</td>
                <td class="px-4 py-3">
                  Lista de <code>CD_ESTABELECIMENTO</code> permitidos. Digite com colchetes no campo do Brand Manager.<br>
                  <ul class="text-xs text-gray-600 dark:text-gray-400 mt-2 space-y-0.5 list-disc list-inside">
                    <li>Com esta lista → exibe apenas os IDs informados (que o usuário também tiver acesso)</li>
                    <li>Sem esta lista → exibe todos os estabelecimentos do usuário</li>
                  </ul>
                  <div class="mt-3 flex items-center gap-2">
                    <span class="text-xs font-semibold text-gray-600 dark:text-gray-400">Lista padrão Clínica SiM:</span>
                    <button (click)="copy(estabelecimentosDefault, 'estabs')"
                      class="text-xs px-2 py-0.5 rounded border border-[var(--brand-primary)] text-[var(--brand-primary)] hover:bg-[var(--brand-primary)] hover:text-white transition-colors">
                      {{ copied === 'estabs' ? 'Copiado!' : 'Copiar' }}
                    </button>
                  </div>
                  <code class="text-xs text-gray-500 dark:text-gray-400 block mt-1 break-all">{{ estabelecimentosDefault }}</code>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- IMAGENS E ÍCONES -->
      <div class="mb-6">
        <div class="bg-[var(--brand-accent)] text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-t-lg">Imagens e Ícones</div>
        <div class="overflow-x-auto border border-t-0 border-gray-200 dark:border-zinc-700 rounded-b-lg">
          <table class="w-full text-sm">
            <thead class="bg-gray-100 dark:bg-zinc-800 text-gray-700 dark:text-gray-200">
              <tr>
                <th class="px-4 py-2 text-left font-semibold w-36">Chave</th>
                <th class="px-4 py-2 text-left font-semibold">Descrição</th>
                <th class="px-4 py-2 text-left font-semibold w-40">Onde aparece</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100 dark:divide-zinc-700 text-gray-700 dark:text-gray-300">
              <tr class="bg-white dark:bg-zinc-900">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">favicon</td>
                <td class="px-4 py-3">URL do favicon (<code>.ico</code> ou <code>.png</code> 32×32). Aparece na aba do browser ao lado do título.</td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Aba do browser</td>
              </tr>
              <tr class="bg-gray-50 dark:bg-zinc-800/50">
                <td class="px-4 py-3 font-mono text-[var(--brand-primary)] font-semibold">footerLogo</td>
                <td class="px-4 py-3">
                  URL de uma imagem alternativa para o logo no footer (ex: versão branca para fundos escuros).<br>
                  <span class="text-xs text-gray-500 mt-1 block">Se vazio → usa o logo principal. Aceita <code>.svg</code> e <code>.png</code>.</span>
                </td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">Footer, tela de login</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <!-- Modelos Prontos -->
    <section class="mb-10">
      <h2 class="text-base font-semibold text-gray-900 dark:text-white mb-3 pb-2 border-b border-gray-200 dark:border-zinc-700">Modelos Prontos</h2>
      <p class="text-sm text-gray-500 dark:text-gray-400 mb-5">Copie e ajuste no campo <strong>Dados Adicionais</strong> do Brand Manager.</p>

      <!-- Modelo 1 — Clínica SiM -->
      <div class="mb-6 rounded-lg border border-gray-200 dark:border-zinc-700 overflow-hidden">
        <div class="flex items-center justify-between px-4 py-3 bg-gray-100 dark:bg-zinc-800">
          <div>
            <span class="font-semibold text-gray-900 dark:text-white text-sm">Modelo 1 — Clínica SiM</span>
            <span class="ml-2 text-xs text-gray-500">Verde + Escuro</span>
          </div>
          <button (click)="copy(modelClinicaSim, 'clinicasim')"
            class="text-xs px-3 py-1 rounded border border-[var(--brand-primary)] text-[var(--brand-primary)] hover:bg-[var(--brand-primary)] hover:text-white transition-colors font-medium">
            {{ copied === 'clinicasim' ? '✓ Copiado!' : 'Copiar' }}
          </button>
        </div>
        <pre class="bg-zinc-950 text-emerald-400 text-xs p-4 overflow-x-auto leading-relaxed">{{ modelClinicaSim }}</pre>
        <div class="px-4 py-2 bg-gray-50 dark:bg-zinc-800 text-xs text-gray-500 flex gap-4">
          <span>primaryColor <strong class="text-gray-700 dark:text-gray-300">#00A859</strong></span>
          <span>secondaryColor <strong class="text-gray-700 dark:text-gray-300">#101820</strong></span>
        </div>
      </div>

      <!-- Modelo 2 — Super Clínica -->
      <div class="mb-6 rounded-lg border border-gray-200 dark:border-zinc-700 overflow-hidden">
        <div class="flex items-center justify-between px-4 py-3 bg-gray-100 dark:bg-zinc-800">
          <div>
            <span class="font-semibold text-gray-900 dark:text-white text-sm">Modelo 2 — Super Clínica</span>
            <span class="ml-2 text-xs text-gray-500">Vermelho + Navy</span>
          </div>
          <button (click)="copy(modelSuperClinica, 'superclinica')"
            class="text-xs px-3 py-1 rounded border border-[var(--brand-primary)] text-[var(--brand-primary)] hover:bg-[var(--brand-primary)] hover:text-white transition-colors font-medium">
            {{ copied === 'superclinica' ? '✓ Copiado!' : 'Copiar' }}
          </button>
        </div>
        <pre class="bg-zinc-950 text-emerald-400 text-xs p-4 overflow-x-auto leading-relaxed">{{ modelSuperClinica }}</pre>
        <div class="px-4 py-2 bg-gray-50 dark:bg-zinc-800 text-xs text-gray-500 flex gap-4">
          <span>primaryColor <strong class="text-gray-700 dark:text-gray-300">#E8001E</strong></span>
          <span>secondaryColor <strong class="text-gray-700 dark:text-gray-300">#0F1F3E</strong></span>
        </div>
      </div>
    </section>

    <!-- Guia de Cores por Segmento -->
    <section class="mb-10">
      <h2 class="text-base font-semibold text-gray-900 dark:text-white mb-3 pb-2 border-b border-gray-200 dark:border-zinc-700">Guia de Cores por Segmento</h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">

        <!-- Super Clínica -->
        <div class="rounded-lg border border-gray-200 dark:border-zinc-700 overflow-hidden">
          <div class="px-4 py-3 bg-[#0F1F3E] text-white">
            <p class="font-semibold text-sm">Super Clínica</p>
            <p class="text-xs text-gray-300">superclinica.com.br</p>
          </div>
          <div class="p-4 bg-white dark:bg-zinc-900 space-y-2 text-xs">
            <div class="flex items-center gap-2"><span class="w-5 h-5 rounded" style="background:#E8001E"></span><div><div class="font-mono font-semibold">#E8001E</div><div class="text-gray-500">primaryColor</div></div></div>
            <div class="flex items-center gap-2"><span class="w-5 h-5 rounded" style="background:#0F1F3E"></span><div><div class="font-mono font-semibold">#0F1F3E</div><div class="text-gray-500">sidebarBg / menuBg / loginCardBg</div></div></div>
            <div class="flex items-center gap-2"><span class="w-5 h-5 rounded border" style="background:#FFFFFF"></span><div><div class="font-mono font-semibold">#FFFFFF</div><div class="text-gray-500">textOnPrimary / loginCardText</div></div></div>
            <p class="text-gray-400 pt-1">💡 Logo branco → <code>loginCardBg: #0F1F3E</code></p>
          </div>
        </div>

        <!-- Clínica SiM -->
        <div class="rounded-lg border border-gray-200 dark:border-zinc-700 overflow-hidden">
          <div class="px-4 py-3 bg-[#101820] text-white">
            <p class="font-semibold text-sm">Clínica SiM</p>
            <p class="text-xs text-gray-300">clinicasim.com</p>
          </div>
          <div class="p-4 bg-white dark:bg-zinc-900 space-y-2 text-xs">
            <div class="flex items-center gap-2"><span class="w-5 h-5 rounded" style="background:#00A859"></span><div><div class="font-mono font-semibold">#00A859</div><div class="text-gray-500">primaryColor</div></div></div>
            <div class="flex items-center gap-2"><span class="w-5 h-5 rounded" style="background:#101820"></span><div><div class="font-mono font-semibold">#101820</div><div class="text-gray-500">sidebarBg</div></div></div>
            <div class="flex items-center gap-2"><span class="w-5 h-5 rounded" style="background:#8B5CF6"></span><div><div class="font-mono font-semibold">#8B5CF6</div><div class="text-gray-500">accentColor</div></div></div>
            <div class="flex items-center gap-2"><span class="w-5 h-5 rounded border" style="background:#FFFFFF"></span><div><div class="font-mono font-semibold">#FFFFFF</div><div class="text-gray-500">loginCardBg (card claro)</div></div></div>
            <p class="text-gray-400 pt-1">💡 Logo colorido em fundo claro → <code>loginCardBg: #FFF</code></p>
          </div>
        </div>

        <!-- Genérico / Exemplo -->
        <div class="rounded-lg border border-gray-200 dark:border-zinc-700 overflow-hidden">
          <div class="px-4 py-3 bg-[#1A1A2E] text-white">
            <p class="font-semibold text-sm">Modelo Escuro</p>
            <p class="text-xs text-gray-300">Para marcas com identidade dark</p>
          </div>
          <div class="p-4 bg-white dark:bg-zinc-900 space-y-2 text-xs">
            <div class="flex items-center gap-2"><span class="w-5 h-5 rounded" style="background:#6B2FA0"></span><div><div class="font-mono font-semibold">#6B2FA0</div><div class="text-gray-500">primaryColor</div></div></div>
            <div class="flex items-center gap-2"><span class="w-5 h-5 rounded" style="background:#FF6B35"></span><div><div class="font-mono font-semibold">#FF6B35</div><div class="text-gray-500">accentColor</div></div></div>
            <div class="flex items-center gap-2"><span class="w-5 h-5 rounded" style="background:#1A1A2E"></span><div><div class="font-mono font-semibold">#1A1A2E</div><div class="text-gray-500">sidebarBg / loginCardBg</div></div></div>
            <div class="flex items-center gap-2"><span class="w-5 h-5 rounded" style="background:#F5F5F5"></span><div><div class="font-mono font-semibold">#F5F5F5</div><div class="text-gray-500">loginBg</div></div></div>
            <p class="text-gray-400 pt-1">💡 Paleta escura com acento quente</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Regras de Ouro -->
    <section>
      <h2 class="text-base font-semibold text-gray-900 dark:text-white mb-3 pb-2 border-b border-gray-200 dark:border-zinc-700">Regras de Ouro para Cores em Saúde</h2>
      <div class="rounded-lg border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 divide-y divide-gray-100 dark:divide-zinc-700 text-sm">
        <div class="px-4 py-3 flex gap-3 text-gray-700 dark:text-gray-300">
          <span>✅</span>
          <span><strong>Verde</strong> (#00A859, #00CD78) — saúde, aprovação, confiança. Funciona como primária em qualquer contexto clínico.</span>
        </div>
        <div class="px-4 py-3 flex gap-3 text-gray-700 dark:text-gray-300">
          <span>✅</span>
          <span><strong>Azul Navy</strong> (#101820, #0F1F3E) — seriedade, tecnologia, confiança. Ideal para <code>sidebarBg</code> e <code>loginCardBg</code> escuro.</span>
        </div>
        <div class="px-4 py-3 flex gap-3 text-gray-700 dark:text-gray-300">
          <span>✅</span>
          <span><strong>Vermelho</strong> (#E8001E, #CC0000) — energia, urgência, ação. Usar como primária com sidebar escuro para equilíbrio.</span>
        </div>
        <div class="px-4 py-3 flex gap-3 text-gray-700 dark:text-gray-300">
          <span>✅</span>
          <span><strong>Roxo</strong> (#8B5CF6, #6B2FA0) — inovação, diferenciação. Combina bem como <code>accentColor</code> sobre fundo escuro.</span>
        </div>
        <div class="px-4 py-3 flex gap-3 text-gray-700 dark:text-gray-300">
          <span>⚠️</span>
          <span>Amarelo/Laranja puros como cor primária — difícil contraste em texto; preferir como <code>accentColor</code>.</span>
        </div>
        <div class="px-4 py-3 flex gap-3 text-gray-700 dark:text-gray-300">
          <span>⚠️</span>
          <span>Fundo claro + logo branco → sempre configurar <code>loginCardBg</code> com cor escura ou da marca.</span>
        </div>
      </div>
    </section>

  </div>
</div>
